import React from 'react'
// components
import ObjectsAndPropertiesContainer from 'containers/ObjectsAndProperties/Register'

const ObjectsAndPropertiesSettingsPage: React.FC = () => <ObjectsAndPropertiesContainer />

export default ObjectsAndPropertiesSettingsPage
